class DynamicLinkEditFormController {
  constructor() {
    this.name = 'dynamicLinkEditForm';
  }
}

export default DynamicLinkEditFormController;
